(() => {
  const selector = ".template-blog .m-blog__list .m-article-card__title a";
  const speed = 420;

  const updateDurations = () => {
    document.querySelectorAll(selector).forEach((title) => {
      const width = title.getBoundingClientRect().width;
      const duration = width > 0 ? width / speed : 0.6;
      title.style.setProperty("--piri-blog-underline-duration", `${duration.toFixed(3)}s`);
    });
  };

  let resizeFrame;
  const updateAfterResize = () => {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(updateDurations);
  };

  updateDurations();
  document.fonts?.ready.then(updateDurations);
  window.addEventListener("resize", updateAfterResize, { passive: true });
})();
